import { Deserializable } from '../../protocols/deserializable';
import { UpdateEmploymentStatusSubmissionData } from './update-employment-status-submission-data';

export class UpdateEmploymentStatusSubmission implements Deserializable {
  public new!: UpdateEmploymentStatusSubmissionData;

  public onDeserialize(): void {
    if (!!this.new) {
      this.new = window.injector.Deserialize.instanceOf(UpdateEmploymentStatusSubmissionData, this.new);
    }
  }
}
